export const VALID_LANGS = ["es", "en", "de", "ca"] as const;

export type ValidLang = (typeof VALID_LANGS)[number];

export const isValidLang = (lang?: string): lang is ValidLang =>
  Boolean(lang && VALID_LANGS.includes(lang as ValidLang));

export const getLangFromPath = (pathname: string) => {
  const [, lang] = pathname.split("/");
  return isValidLang(lang) ? lang : undefined;
};

export const stripLangPrefix = (pathname: string) => {
  const parts = pathname.split("/");

  if (isValidLang(parts[1])) {
    const withoutLang = `/${parts.slice(2).join("/")}`;
    return withoutLang === "/" ? "/" : withoutLang.replace(/\/$/, "");
  }

  return pathname || "/";
};

export const withLangPrefix = (pathname: string, lang: ValidLang) => {
  const pathWithoutLang = stripLangPrefix(pathname);
  return pathWithoutLang === "/" ? `/${lang}` : `/${lang}${pathWithoutLang}`;
};
